import { getToken } from '../auth/tokenStore';
import { Config } from '../common/types';
import { apiBaseUrl } from '../index';

// Define the set of config keys (values should correspond to keys in the app config in Azure)
enum ConfigKey {
  SUBSCRIPTION_PLUS_PRICE = 'subscription:plusprice',
  SUBSCRIPTION_PLUS_LINK = 'subscription:pluslink'
}

// Retrieve the config
export const getConfig = async (): Promise<Config> => {
  const accessToken: string = await getToken();
  const response = await fetch(`${apiBaseUrl}/config`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  const rawConfig = await response.json();

  const config = {
    plusPlanSubscriptionPrice: rawConfig[ConfigKey.SUBSCRIPTION_PLUS_PRICE],
    plusPlanSubscriptionLink: rawConfig[ConfigKey.SUBSCRIPTION_PLUS_LINK]
  };

  return config;
};
